import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Compass, ArrowLeft, Search, HelpCircle, Zap } from 'lucide-react';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'var(--bg, #fbfbfd)',
        color: 'var(--text, #0a0a0b)',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <header
        style={{
          borderBottom: '1px solid var(--border, #e8e8ed)',
          padding: '16px 24px',
          background: 'rgba(255,255,255,0.85)',
          backdropFilter: 'blur(16px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <button
          onClick={() => navigate('/')}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            background: 'none',
            border: 'none',
            color: 'var(--text-secondary, #6b6b76)',
            fontSize: '14px',
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          <ArrowLeft size={16} /> Back to KhelDrop
        </button>
        <div style={{ fontWeight: 800, fontSize: '15px', display: 'flex', alignItems: 'center', gap: '6px' }}>
          <Zap size={16} /> KhelDrop Arcade Network
        </div>
      </header>

      <main
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '40px 20px',
          textAlign: 'center',
          maxWidth: '560px',
          margin: '0 auto',
        }}
      >
        <div
          style={{
            width: '80px',
            height: '80px',
            borderRadius: '24px',
            background: 'rgba(109, 40, 217, 0.08)',
            color: '#6d28d9',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '24px',
          }}
        >
          <Compass size={40} />
        </div>

        <div
          style={{
            fontSize: '12px',
            fontWeight: 800,
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            color: '#6d28d9',
            background: 'rgba(109, 40, 217, 0.1)',
            padding: '4px 12px',
            borderRadius: '999px',
            marginBottom: '12px',
          }}
        >
          404 Not Found
        </div>

        <h1
          style={{
            fontSize: '32px',
            fontWeight: 900,
            margin: '0 0 12px',
            letterSpacing: '-0.02em',
            color: 'var(--text, #0a0a0b)',
          }}
        >
          This match lobby has moved or does not exist.
        </h1>

        <p
          style={{
            fontSize: '14px',
            lineHeight: 1.6,
            color: 'var(--text-secondary, #6b6b76)',
            margin: '0 0 32px',
          }}
        >
          The page or game route you followed might have expired, had its turf slot filled, or been entered incorrectly.
        </p>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', justifyContent: 'center' }}>
          <button
            onClick={() => navigate('/')}
            style={{
              background: '#111111',
              color: '#ffffff',
              border: 'none',
              borderRadius: '999px',
              padding: '12px 24px',
              fontSize: '14px',
              fontWeight: 700,
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <Compass size={16} /> Explore Match Radar
          </button>

          <Link
            to="/help"
            style={{
              background: 'var(--elevated, #f4f4f6)',
              color: 'var(--text, #0a0a0b)',
              border: '1px solid var(--border, #e8e8ed)',
              borderRadius: '999px',
              padding: '12px 20px',
              fontSize: '14px',
              fontWeight: 600,
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
            }}
          >
            <HelpCircle size={16} /> Help Center
          </Link>
        </div>
      </main>
    </div>
  );
}
